"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
interface AutoRotate {
  active: number;
  /** Picking by hand ends the auto-play — the visitor is driving now. */
  select: (index: number) => void;
  /** True while the timer is genuinely running, so the UI can show progress. */
  running: boolean;
  hoverProps: {
    onMouseEnter: () => void;
    onMouseLeave: () => void;
  };
}

// Cycles an index on a timer until the visitor takes over. Hovering pauses;
// clicking stops for good, since an auto-advance that fights a deliberate
// choice is the fastest way to make a section feel broken.
export const useAutoRotate = (count, intervalMs, t0) => {
  const $ = _c(16);
  const enabled = t0 === undefined ? true : t0;
  const [active, setActive] = useState(0);
  const [auto, setAuto] = useState(true);
  const [hovering, setHovering] = useState(false);
  const running = enabled && auto && !hovering && count > 1;
  let t1;
  if ($[0] !== count || $[1] !== intervalMs || $[2] !== running) {
    t1 = () => {
      if (!running) {
        return;
      }
      const id = setTimeout(() => setActive(i => (i + 1) % count), intervalMs);
      return () => clearTimeout(id);
    };
    $[0] = count;
    $[1] = intervalMs;
    $[2] = running;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== active || $[5] !== count || $[6] !== intervalMs || $[7] !== running) {
    t2 = [running, active, count, intervalMs];
    $[4] = active;
    $[5] = count;
    $[6] = intervalMs;
    $[7] = running;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index => {
      setActive(index);
      setAuto(false);
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const select = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setHovering(true);
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setHovering(false);
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      onMouseEnter: t4,
      onMouseLeave: t5
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const hoverProps = t6;
  let t7;
  if ($[13] !== active || $[14] !== running) {
    t7 = {
      active,
      select,
      running,
      hoverProps
    };
    $[13] = active;
    $[14] = running;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};